import { memo } from 'react';
import { useT } from '../../translation/src';

/**
 * A label that may be a translation key (built-in types and categories are
 * `t()`-marked) or a plain organisation string (no catalog entry → shown as is).
 */
const TranslatedLabel_: React.FC<{ label: string; swc?: boolean }> = ({ label, swc }) => <>{useT(label, swc ? { swc: true } : undefined)}</>;

export const TranslatedLabel = memo(TranslatedLabel_);
